import { FIXED_INDENTS } from 'vars/index'

export const SidebarPaddings = {
  SIZE_0: [FIXED_INDENTS.INDENT_0],
  SIZE_10: [
    FIXED_INDENTS.INDENT_80,
    FIXED_INDENTS.INDENT_140,
    FIXED_INDENTS.INDENT_140,
    FIXED_INDENTS.INDENT_140,
  ],
}
export type SidebarPadding =
  (typeof SidebarPaddings)[keyof typeof SidebarPaddings]

export const SidebarPosition = {
  TopLeft: 'top-left',
  TopRight: 'top-right',
  BottomLeft: 'bottom-left',
  BottomRight: 'bottom-right',
} as const
export type SidebarPosition =
  (typeof SidebarPosition)[keyof typeof SidebarPosition]
